export const USER_ROLES = {
  ADMIN: 'ADMIN',
  USER: 'USER'
}
